import styled from 'styled-components';
import Dropdown from 'core/dropdown';
import { pxToRem } from 'utils/convert';
import { Button } from '@iterable/deprecated_react_components';

const sharedButtonStyles = `
    background: rgba(0, 0, 0, 0.1);
    border-radius: ${pxToRem(3)};
    display: inline-flex;
    align-items: center;
    margin: ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(4)} 0;
    padding: ${pxToRem(4)} ${pxToRem(10)};
    transition: background 0.2s, color 0.2s;
    &:hover {
      background: #eaf4fa;
      color: #2e8ece;
    }`;

export const StyledCoreButton = styled(Button)`
  &&&&&&& {
    ${sharedButtonStyles};
  }
`;

export const StyledCoreButtonAlt = styled(Button)`
  &&&&&&& {
    ${sharedButtonStyles};
    box-shadow: none;
    text-transform: none;
    font-size: ${pxToRem(13)};
    text-shadow: none;
    border: ${pxToRem(1)} solid transparent;
    &:hover {
      border: ${pxToRem(1)} solid transparent;
    }
  }
`;

export const StyledCoredDropdown = styled(Dropdown)`
  &&&&& {
    display: flex !important;
    > .action {
      align-items: center;
      display: flex;
      .dropdown.icon {
        align-items: center;
        display: flex;
        justify-content: flex-end;
        margin-left: ${pxToRem(5)} !important;
      }
    }
  }
`;

export const SelectedItemContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
`;

export const ItemsSelectedLabel = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${pxToRem(10)};
  color: #717171;
`;

export const BulkActionsRowContainer = styled.div<{ $isIterableStyle: boolean }>`
  display: flex;
  position: absolute;
  align-items: center;
  top: 0;
  right: 0;
  min-height: ${pxToRem(32)};
  left: ${pxToRem(38)};
  z-index: 10;
  [data-appearance='normal'] & {
    background: ${({ $isIterableStyle }) => ($isIterableStyle ? '#444' : '#eff0f0')};
  }
  [data-theme='dark'] .main[data-appearance='normal'] {
    background: #222;
  }
  [data-role='toolbar'] > & {
    left: 0;
    padding-left: ${pxToRem(4)};
  }
  [data-appearance='iterable'] > [data-role='table'] & {
    ${StyledCoreButton},
    ${StyledCoreButtonAlt} {
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      &:hover {
        background: #eaf4fa;
        color: #2e8ece;
      }
    }
    ${ItemsSelectedLabel} {
      color: #fff;
    }
  }
`;
